import { Component } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core';
import { SavedFilterViewsService } from "../../../service/services/misc/saved-filter-views/saved-filter-views.service";

@Component({
    selector: 'app-save-filter-view-dialog',
    templateUrl: './save-filter-view-dialog.component.html',
    styleUrls: ['./save-filter-view-dialog.component.scss'],
    standalone: false
})
export class SaveFilterViewDialogComponent {
    viewName: string = '';
    errorMessage: string = '';
    setAsDefault: boolean = false;
    organizationPath?: string;
    currentViewName?: string;

    constructor(
        public dialogRef: DialogRef,
        private savedFilterViewsService: SavedFilterViewsService
    ) {
        // Get organizationPath and currentViewName from dialog data if provided
        this.organizationPath = this.dialogRef.data?.organizationPath;
        this.currentViewName = this.dialogRef.data?.currentViewName;

        // Pre-populate viewName with currentViewName if it's not "Standard"
        if (this.currentViewName && this.currentViewName !== 'Standard') {
            this.viewName = this.currentViewName;
            // Initialize setAsDefault from existing view's isDefault property
            const existingView = this.savedFilterViewsService.getView(this.currentViewName);
            if (existingView) {
                this.setAsDefault = existingView.isDefault || false;
            }
        }
    }

    isValid(): boolean {
        const trimmedName = this.viewName.trim();
        if (trimmedName.length === 0) {
            return false;
        }

        // Cannot save with the name "Standard" (case-insensitive)
        if (trimmedName.toLocaleLowerCase() === 'standard') {
            return false;
        }

        // If the name matches the current view (without *), allow it (overwrite)
        if (this.currentViewName && trimmedName === this.currentViewName) {
            return true;
        }

        // Otherwise, check for duplicates
        return !this.savedFilterViewsService.viewExists(trimmedName);
    }

    onSave(): void {
        if (!this.viewName || this.viewName.trim() === '') {
            this.errorMessage = 'Please enter a name for the filter view';
            return;
        }

        const trimmedName = this.viewName.trim();

        // Cannot save with the name "Standard" (case-insensitive)
        if (trimmedName.toLocaleLowerCase() === 'standard') {
            this.errorMessage = '"Standard" is a reserved name. Please choose a different name';
            return;
        }

        // If the name matches the current view, allow it (overwrite)
        if (this.currentViewName && trimmedName === this.currentViewName) {
            this.dialogRef.close({ name: trimmedName, setAsDefault: this.setAsDefault });
            return;
        }

        // Check for duplicates with other views
        if (this.savedFilterViewsService.viewExists(trimmedName)) {
            this.errorMessage = 'This view name already exists. Please enter a different name';
            return;
        }

        this.dialogRef.close({ name: trimmedName, setAsDefault: this.setAsDefault });
    }

    onInputChange(): void {
        // Clear error message when user types
        this.errorMessage = '';

        const trimmedName = this.viewName.trim();

        if (trimmedName.length === 0) {
            return;
        }

        // Check for reserved name "Standard" (case-insensitive)
        if (trimmedName.toLocaleLowerCase() === 'standard') {
            this.errorMessage = '"Standard" is a reserved name. Please choose a different name';
            return;
        }

        // If the name matches the current view, it's valid (allow overwrite)
        if (this.currentViewName && trimmedName === this.currentViewName) {
            return; // No error, user can save over current view
        }

        // Check for duplicates with other views
        if (this.savedFilterViewsService.viewExists(trimmedName)) {
            this.errorMessage = 'This view name already exists. Please enter a different name';
        }
    }
}
